import React, { FC, useEffect } from 'react';
// @ts-ignore
import { useAnalytics } from 'use-analytics';
import { useLocation } from 'react-router-dom';

const GoogleAnalyticsPageView: FC = () => {
  let location = useLocation();
  const analytics = useAnalytics();

  useEffect(() => {
    analytics.page({ pathname: location.pathname });
  }, [location, analytics]);

  return <></>;
};

export { GoogleAnalyticsPageView };

export default GoogleAnalyticsPageView;
